import { Form, Input, Space, Table, Tooltip } from "antd";
import React from "react";
import { TableUi } from "../../ui/TableUi";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { useDispatch } from "react-redux";
import { reglaListaprecioSetActive } from "../../../actions/listaprecio";
const columns = (props) => {
  const { form, handleEditar, handleEliminar } = props;
  return [
    {
      title: "N°",
      dataIndex: "nro",
      key: "nro",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "Tipo calculo",
      dataIndex: "tipocalculo_nombre",
      key: "tipocalculo_nombre",
      render: (text, record, index) => (
        <>
          {form.getFieldValue([
            "reglaslistaprecios",
            record?.name,
            "tipocalculo_nombre",
          ])}
        </>
      ),
    },
    {
      title: "Valor",
      dataIndex: "monto",
      key: "monto",
      render: (text, record) => (
        <>{form.getFieldValue(["reglaslistaprecios", record?.name, "monto"])}</>
      ),
    },
    {
      title: "Aplicar sobre",
      dataIndex: "aplicar_nombre",
      key: "aplicar_nombre",
      render: (text, record) => (
        <>
          {form.getFieldValue([
            "reglaslistaprecios",
            record?.name,
            "aplicar_nombre",
          ])}
        </>
      ),
    },
    {
      title: "Cantidad Min.",
      dataIndex: "cantidadminima",
      key: "cantidadminima",
      render: (text, record) => (
        <>
          {form.getFieldValue([
            "reglaslistaprecios",
            record?.name,
            "cantidadminima",
          ])}
        </>
      ),
    },

    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => {
        const row = form.getFieldValue(["reglaslistaprecios", record?.name]);
        return (
          <Space size="middle">
            <Tooltip title="Editar">
              <ButtonUi
                typeUi={TipoButtonConstants.EditarTable}
                onClick={() => handleEditar(row)}
                displayText={false}
                size="small"
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <ButtonUi
                typeUi={TipoButtonConstants.EliminarTable}
                onClick={() => handleEliminar(row)}
                displayText={false}
                ghost
                size="small"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];
};
export const ListaPrecioReglasTable = ({ data, onOpen, title }) => {
  const forminstance = Form.useFormInstance();
  const [form] = Form.useForm(forminstance);
  const dispatch = useDispatch();
  const handleEditar = (record) => {
    dispatch(reglaListaprecioSetActive(record));
    onOpen();
  };
  const handleEliminar = (itemDelete) => {
    const ReglasListaPrecio = form.getFieldValue("reglaslistaprecios") || [];
    const reglasAfterRemove = ReglasListaPrecio.filter(
      (item) => item.id !== itemDelete?.id
    );
    form.setFieldValue("reglaslistaprecios", reglasAfterRemove);
  };
  return (
    <TableUi
      data={data}
      columns={columns({ form, handleEditar, handleEliminar })}
      rowKey="id"
      size="small"
      title={title}
    />
  );
};
